import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, FileUpload, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const MarketingMediaUploadPage = () => {
    //const storeAdmin = useStoreAdmin();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [files, setFiles] = React.useState<File[]>([]);
    const [file, setFile] = React.useState<any | null>(null);

    const { navigate } = useRouter();
    const { menu, } = useGlobalState();
    useEffect(() => {

    }, []);

    const handleFileUpload = async () => {

        try {
            setLoading(true)
            console.log(file);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/medias/upload',
                },
                body: JSON.stringify(file),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
                setFiles([]);
                setFile(null);

            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    const handleFileChange = async (files: File[]) => {
        try {
            // Use Promise.all to concurrently convert all files to Base64
            const base64Results = await Promise.all(files.map(fileToBase64));

            // Map the results back to an array of objects that include the Base64 data hjjhg 
            const attachmentsWithBase64 = base64Results.map(result => ({
                fileName: result.file.name,
                fileContent: result.base64,
                fileSize: result.file.size,
            }));
            setFile(attachmentsWithBase64[0]);
        } catch (error) {
            console.error('Error reading files:', error);
            // Handle error state if necessary
        }
    };

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Cargar pieza publicitaria</Header>
                    <SpaceBetween size="m" direction='vertical'>
                        <FileUpload
                            onChange={({ detail }) => {
                                const lastSelectedFile = detail.value.slice(-1);
                                if (lastSelectedFile.length > 0) {
                                    const file = lastSelectedFile[0];
                                    if (file.size > 2 * 1024 * 1024) { // 2MB limit
                                        alert("El archivo excede el tamaño máximo permitido de 2MB.");
                                        return;
                                    }
                                }
                                setFiles(lastSelectedFile);
                                handleFileChange(lastSelectedFile);
                            }}
                            accept="video/mp4"
                            value={files}
                            multiple={false}
                            constraintText="Tamaño máximo 2MB."
                            i18nStrings={{
                                uploadButtonText: e => (e ? "Cambiar archivo" : "Seleccionar archivo"),
                                dropzoneText: e => (e ? "Suelte el archivo para reemplazar" : "Suelte el archivo aquí"),
                                removeFileAriaLabel: e => `Eliminar archivo ${e + 1}`,
                                limitShowFewer: "Mostrar menos",
                                limitShowMore: "Mostrar más",
                                errorIconAriaLabel: "Error"
                            }}
                            showFileSize
                            showFileThumbnail
                            showFileLastModified
                            fileTokenAlignment="horizontal"
                            tokenLimit={1}

                        />
                        <Button variant="primary" onClick={() => {
                            if (file) {
                                // Aquí puedes manejar el archivo convertido a Base64 (file.base64)
                                handleFileUpload();
                            }
                        }} disabled={!file}>Cargar</Button>

                    </SpaceBetween>
                </SpaceBetween>
            }
        />
    )
};
